import React from 'react';
import { insertFiles } from '../../../markup/commands';
import { ToolbarFile } from '../custom/ToolbarFile';
import { useMarkupToolbarContext } from './context';
export const MToolbarFile = ({ focus, onClick, editor, className }) => {
    const { uploadHandler } = useMarkupToolbarContext();
    return (React.createElement(ToolbarFile, { focus: focus, onClick: onClick, className: className, active: false, enable: true, onSubmit: (fileParams) => insertFiles(editor.cm, [fileParams]), uploadHandler: uploadHandler, onSuccessUpload: (res) => {
            insertFiles(editor.cm, res.success.map(({ result, file }) => {
                var _a, _b;
                return ({
                    src: result.url,
                    name: (_a = result.name) !== null && _a !== void 0 ? _a : file.name,
                    type: (_b = result.type) !== null && _b !== void 0 ? _b : file.type,
                });
            }));
        } }));
};
